import { render, staticRenderFns } from "./SearchActiveCustomers.vue?vue&type=template&id=1878da22&scoped=true&"
import script from "./SearchActiveCustomers.vue?vue&type=script&lang=js&"
export * from "./SearchActiveCustomers.vue?vue&type=script&lang=js&"
import style0 from "./SearchActiveCustomers.vue?vue&type=style&index=0&id=1878da22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878da22",
  null
  
)

export default component.exports